import { ApiListings, ApiLicensor } from '@cf/api-v2-types';
import type { Writable } from 'svelte/store';

export async function fetchLicensorData(currentSubdomain: string) {
  let markForReviewCount = 0;
  let licensors: any[] = [];
  let error: string | null = null;
  let selectedLicensor: any = null;

  const apiLicensor = new ApiLicensor("/proxy");
  try {
    const response = await apiLicensor.getActiveLicensors();
    
    licensors = response?.licensors?.map?.((licensor: { display_name: any; name: any; }) => ({
      ...licensor,
      displayName: licensor.display_name || licensor.name || 'Unnamed Licensor',
    })) ?? [];
    
    selectedLicensor = licensors.find(l => l.subdomain === currentSubdomain) || licensors[0];

    if (selectedLicensor?.id) {
      const apiListings = new ApiListings("/proxy");
      markForReviewCount = await apiListings.getMarkForReviewCount(selectedLicensor.id);
    }
  } catch (err) {
    console.error("Error fetching licensors:", err);
    error = err instanceof Error ? err.message : "An unknown error occurred";
  }

  return { markForReviewCount, licensors, selectedLicensor, error };
}